export default "__VITE_ASSET___Z3RkT6k__"